import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-gradient-primary rounded-2xl flex items-center justify-center shadow-elevated">
          <Icon name="Newspaper" size={32} color="white" />
        </div>
      </div>
      <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
        Join News Mind AI
      </h1>
      <p className="text-muted-foreground text-lg">
        Create your account to access AI-powered journalism tools
      </p>
      <p className="text-sm text-muted-foreground mt-2">
        Generate news, verify facts, and detect bias with professional-grade tools
      </p>
    </div>
  );
};

export default RegistrationHeader;